// ##############################
// // // Button Group styles
// #############################

import { blackColor } from '../../../assets/styles/jss/main';

const sepStyle = {
  root: {
    position: 'relative',
    overflow: 'visible',
    borderColor: '#ccced0',
    '&:before': {
      content: 'attr(data-content)',
      position: 'relative',
      display: 'inline-block',
      color: blackColor,
      padding: '0 1rem',
      lineHeight: '1.5rem',
      backgroundColor: '#FFF',
      transform: 'translateY(-13px)',
    },
  },
  withMargin: {
    margin: '40px 0',
  },
};

export default sepStyle;
